import { SUB_AREA_ACTION_TYPES } from '../../actions/sub_area/sub_area_action';

const initialState = {
    page: 0,
    rowsPerPage: 10,
    totalCount: 0,
    collection: [],
    filters: {}
};

export const subAreas = (state = initialState, action) => {
    switch (action.type) {
        case SUB_AREA_ACTION_TYPES.GET__SUB_AREAS_SUCCESS:
            return { ...state, collection: action.payload };
        case SUB_AREA_ACTION_TYPES.POST_SUB_AREA_SUCCESS:
            return { ...state, collection: [action.payload, ...state.collection], totalCount: state.totalCount + 1 };
        case SUB_AREA_ACTION_TYPES.PUT_SUB_AREA_SUCCESS:
            const updatedSubArea = action.payload;
            return { ...state, collection: state.collection.map((subArea) => subArea.uuid !== updatedSubArea.uuid ? subArea : { ...subArea, ...updatedSubArea }) };
        case SUB_AREA_ACTION_TYPES.UPDATE_SUB_AREAS_PAGINATION:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
